
/**
 * Auto-generated by generate-icon-index.js
 * To make any changes, update the ./scripts/generate-icon-index.js script.
*/

import React from 'react'
import * as defaultIcons from './default'
import defaultIconConfig from './default/config.json'
import * as tenantIcons from './scatters'
import iconConfig from './scatters/config.json'

const toPascalCase = (str) =>
  str
    .split(/[-_]/)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join('')

const Icon = ({ name, width = '24px', height = '24px', ...props }) => {

  // Start with the requested name, but allow config to override it
  // This allows mapping multiple logical names to a single icon file
  const config = iconConfig[name] || defaultIconConfig[name]

  let resolvedName = name
  let iconProps = {
    ...props,
    ...(width !== 'auto' && { width }),
    ...(width !== 'auto' && height !== 'auto' && { height }),
  }

  if (config) {
    resolvedName = config.name || name

    iconProps = {
      ...iconProps,
      ...config, // this will override props with any matching keys from config
    }
  }

  const iconName = toPascalCase(resolvedName)
  const IconComponent = tenantIcons[iconName] || defaultIcons[iconName]

  if (!IconComponent) {
    const notFoundProps = {}
    if (props.className) {
      notFoundProps.className = props.className
    }
    return <div style={{ color: 'red' }} {...notFoundProps}>Icon not found: {name}</div>
  }

  return <IconComponent {...iconProps} />
}

export default Icon
